import { html, TemplateResult, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';

import { DERElement } from '~/common/der-element';
import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './stepper.styles';
type Step = {
    label: string;
    content: TemplateResult;
};

export class Stepper extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    @property({ type: Array }) steps: Step[] = [];

    override render() {
        return html`
            <ul class="c-stepper">
                ${this.steps.map(
                    (step, index) => html`
                        <li class="c-stepper__item" key=${index}>
                            <div class="c-stepper__content">
                                <span class="c-stepper__item-label">${step.label}</span>
                                ${step.content}
                            </div>
                        </li>
                    `
                )}
            </ul>
        `;
    }
}
